import { useMerchantList } from "@HOOKS";
const useLogics = () => {
  const merchants = useMerchantList();
  const columns = [
    {
      title: "Şehir",
      key: "CITY_NAME",
      dataIndex: "CITY_NAME",
      width: 250,
      fixed: true,
    },
    {
      title: "İlçe",
      key: "TOWN_NAME",
      dataIndex: "TOWN_NAME",
      width: 250,
      fixed: true,
    },
    {
      title: "Mahalle",
      key: "DISTRICT_NAME",
      dataIndex: "DISTRICT_NAME",
      width: 200,
    },
  ];

  const excelColumns = [
    {
      title: "Şehir",
      key: "CITY_NAME",
    },
    {
      title: "İlçe",
      key: "TOWN_NAME",
    },
    {
      title: "Mahalle",
      key: "DISTRICT_NAME",
    },
  ].filter(Boolean);
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
